// This file is auto-generated.
// It's responsible for giving the view it's own Flow context.

import { Flow } from 'Simple/Flow'
import React from 'react'
import SendPatientMessage from './data'

export default function SendPatientMessageFlow({ children, ...props }) {
  return (
    <Flow viewPath={props.viewPath} flowDefinitionViewPathSource="/DesignSystem/SendPatientMessage">
      <SendPatientMessage {...props}>
        {children}
      </SendPatientMessage>
    </Flow>
  )
}
